<template>
  <section class="story05">
    <div class="container">
      <h2 class="story05--tit">botalab</h2>
      <div class="story05--desc">자연에서 찾은 프리미엄 퍼스널케어 </div>
      <!-- <img src="@/assets/images/brandstory/logo_typo.png" class="story05--logo" alt="botalab"> -->
      <div class="row">
        <div class="col-sm-6 story05--c" @click="mobeToProtuctsPage">
          <img src="@/assets/images/brandstory/botalab_product01.png" class="story05--img" alt="botalab hair">
          <div class="story05--htxt">보이지 않는 두피도<span class="brs"></span> 피부니까!</div>
          <div class="story05--htxt2">당신의 삶을 아름답게<span class="brs"></span> 변화시킬 프리미엄 <span class="brs"></span>퍼스널케어</div>
          <button class="btn-st" type="button">hair</button>
        </div>
        <div class="col-sm-6 story05--c" @click="mobeToProtuctsPageBody">
          <img src="@/assets/images/brandstory/botalab_product03.png" class="story05--img" alt="botalab body care">
          <div class="story05--htxt">나를 바꾸는 <span class="brs"></span>3가지 좋은 습관!</div>
          <div class="story05--htxt2">#복잡한 기억 씻어내기<span class="brs"></span>#어지러운 마음 비우기<span class="brs"></span>#긍정으로 나 채우기</div>
          <button class="btn-st" type="button">body care</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Section6',
  methods: {
    mobeToProtuctsPage() {
      this.$router.push('/products');
    },
    mobeToProtuctsPageBody() {
      this.$router.push('/products#body');
    },
  },
};
</script>